import React from 'react';
import Search from './Search/Search';

const DashHeader = () => {
    
    return (
        <div>
            <Search />
        </div>
    );
};

export default DashHeader;